import { z } from "zod";

import type { GetImpulseFormInputSetter } from "~/tools/impulse-form";

import { WidgetQuery } from "../../components/widget-form/query/form-state";

import { partial, tuple } from "./_decoders";
import { Encoder } from "./_encoder";

type FormState = WidgetQuery;

const decoder = tuple([
	z.string().optional().catch(undefined),
	z.string().optional().catch(undefined),
	z.string().optional().catch(undefined),
])
	.transform(
		([promql, alias, minStep]) =>
			partial({ promql, alias, minStep }) satisfies undefined | GetImpulseFormInputSetter<FormState>,
	)
	.catch(undefined);

const DEFAULT = WidgetQuery.default;

function encoder(query: z.infer<typeof decoder>): Encoder {
	return Encoder.tuple(
		Encoder.primitive(query?.promql, DEFAULT.promql),
		Encoder.primitive(query?.alias, DEFAULT.alias),
		Encoder.primitive(query?.minStep, DEFAULT.minStep),
	);
}

const FormState = { encoder, decoder };

export { FormState };
